import { render, staticRenderFns } from "./BlacklistPopup.vue?vue&type=template&id=4042123c&"
import script from "./BlacklistPopup.vue?vue&type=script&lang=js&"
export * from "./BlacklistPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports